import Splitting from "splitting";

export default class HeroVideo {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.hero-video__section'), el => {
            new HeroVideo(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            this.setToActiveState();
            return;
        }

        this.splitIntoLines(element.querySelector('.hero-video__content p'));

        const addLoaded = () => !this.element.classList.contains('active') && this.element.classList.add('loaded');
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', addLoaded, {once: true});
        } else {
            addLoaded();
        }

        setTimeout(() => {
            this.setToActiveState();
        }, 1000)
    }

    splitIntoLines(content) {
        const results = Splitting({target: content, by: 'lines'});

        results[0]?.lines?.forEach((el, index) => {
            el.forEach((_el) => {
                _el.style.setProperty('--line-index', index);
            });
        });
    }

    setToActiveState() {
        this.element.classList.remove('loaded');
        this.element.classList.add('active');
    }
}
